<template>
  <form @submit.prevent>
    <div>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
        <span v-else>{{ $t("electronic-storage.new") }}</span>
      </h2>

      <!-- form input start-->
      <sweet-input
        v-model="form.name"
        :isValid="!$v.form.name.$error"
        @input="$v.form.name.$touch()"
        layout="vertical"
        :placeholder="$t('common.name')"
        :label="$t('electronic-storage.text')"
      />

      <div class="col-mr-5 mt-3">
        <right-panel
          class="float-right mt-1 "
          id="sidebar-new-electronic-storage-category"
          width="650px"
          :icon="'mdi mdi-plus'"
          :text="$t('electronic-storage-category.new')"
          @hidden="rightPanelClosed"
        >
          <div class="pl-5 pr-5">
            <Form :hide-library="true" @onSave="onCategorySelect" />
          </div>
        </right-panel>
      </div>

      <h6 class="mt-4">{{ $t("electronic-storage-category.text") }}</h6>
      <filter-select
        :validation="true"
        :isValid="!$v.form.category.$invalid"
        id="categoryFilter"
        ref="categoryFilter"
        :placeholder="$t('electronic-storage-category.text')"
        :multiple="false"
        @filter="onCategorySearch"
        :selected="form.category"
        @changed="onCategorySelect"
      />
      <br />

      <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
        {{ $t("common.save") }}
      </sweet-button>
    </div>
  </form>

  <!-- form input end -->
</template>

<script>
import Form from "./workspace-library-electronic-storage-category-form.vue";

import { maxLength, minLength, required } from "vuelidate/lib/validators";
const state = "workspaceElectronicStorage";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
    inventory: { type: Boolean },
  },
  components: {
    Form,
  },
  data() {
    return {
      form: {
        name: undefined,
        category: undefined,
      },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      category: {
        required,
      },
    },
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = { ...this.prepareFormForEdit(v) };
      },
    },
  },
  computed: {
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch(`${state}/save`, this.form);
        this.form = {};
        this.$toast.success(this.$t("common.success"));
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-electronic-storage");
        }
        setTimeout(() => this.$emit("onFormSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    rightPanelClosed() {
      this.$refs.categoryFilter.reset();
    },

    async onCategorySearch(value, callback) {
      let path = this.inventory ? "electronicStorageCategory" : "workspaceElectronicStorageCategory";

      const response = await this.$store.dispatch(`${path}/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onCategorySelect(category) {
      this.form = { ...this.form, category };
    },
  },
};
</script>
